import { COLORS } from '@/constants/calculator';

const PURPLE_BORDER = { borderColor: COLORS.PURPLE };
const ORANGE_BORDER = { borderColor: COLORS.ORANGE };
const PURPLE_TEXT = { color: COLORS.PURPLE };
const ORANGE_TEXT = { color: COLORS.ORANGE };

export const CostComparison = ({ managedCost, selfDeliveryCostInclusive, totalCosts }) => (
  <div className="bg-white border border-slate-200 p-8 mb-8">
    <label className="text-xs tracking-[0.2em] uppercase font-bold text-slate-500 block mb-8">
      COST COMPARISON
    </label>

    <div className="grid grid-cols-2 gap-6 mb-8">
      <div className="border-l-4 pl-4" style={PURPLE_BORDER}>
        <p className="text-sm text-slate-500 mb-2">Managed Installation</p>
        <p className="text-4xl font-black" style={PURPLE_TEXT} data-testid="result-managed-cost">
          ${managedCost}
        </p>
        <p className="text-xs text-slate-500 mt-1">per hour</p>
      </div>

      <div className="border-l-4 pl-4" style={ORANGE_BORDER}>
        <p className="text-sm text-slate-500 mb-2">Self Delivery (cost-inclusive)</p>
        <p className="text-4xl font-black" style={ORANGE_TEXT} data-testid="result-self-delivery-cost">
          ${selfDeliveryCostInclusive.toFixed(2)}
        </p>
        <p className="text-xs text-slate-500 mt-1">per hour</p>
      </div>
    </div>

    <div className="bg-slate-50 border border-slate-200 p-6">
      <div className="flex justify-between items-center">
        <span className="text-base font-medium text-slate-700">Total Management Cost</span>
        <span className="text-2xl font-bold text-slate-900" data-testid="total-deduction">
          ${totalCosts.toFixed(2)}/hr
        </span>
      </div>
      <p className="text-sm text-slate-500 mt-2">
        These are the hidden hourly costs added on top of the bare hourly rate when delivering with your own labour.
      </p>
    </div>
  </div>
);
